import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'

const { Option } = Select 
const axios = require("axios");

/**
 * @const SelectInversion
 * @description Select para las inversiones registrados en el sistema
 */
const SelectInversion = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione la inversión", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        mode = null
    } = props


    const [ inversiones, setInversiones ] = useState({
        data: [],
        page: 1,
        limit: 100,
        total: 0,
        search: null,
    })


    /**
     * @const getInversiones
     * @description Obitiene las inversiones
     */
    const getInversiones = ({page, limit, search} = inversiones) => {

        axios.get('/inversiones/list', {
            params: {
                page,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            setInversiones(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener las inversiones')
        })
    }

    //componentDidMount
    useEffect(() => {
        getInversiones()
    }, [])

    useEffect(() => {
        onChange(value?.value ?? value)
    }, [value])

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            mode={mode}
            onSearch={(search)=> getInversiones({search})}
            onSelect={(inversion)=> {
                if(mode === null){
                    onChange(inversion.value)
                    onSelect(inversion.value)
                }
            }}
            onChange={(values)=>{
                if(mode === "multiple"){
                    let arr = values.map(e => e.value)
                    onChange(arr)
                    onSelect(arr)
                }
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                inversiones?.data?.map(({ _id, nombre, monto_restante }) => <Option value={_id} key={_id}>
                    <div className="flex-between"><span>{nombre ?? ""}</span> <small> $ { monto_restante.toMoney(true)}</small></div>
                </Option>)
            }
        </Select>
    );
}



export default SelectInversion;